import { AreaChart } from '@clickcease/cc-client-components-lib'
import { chartOptions } from './utilities'
import { AreaSPLineProps } from './types'
import React, { useMemo } from 'react'
import { CSS } from '@stitches/react'

const defaultCSS: CSS = { width: '916px', marginTop: '36px', height: '380px' }

export const AreaSPLine = ({ data, chartCSS, options }: AreaSPLineProps) => {
  const optionsWithData = useMemo(() => ({ ...chartOptions(data), ...options }), [data, options])
  return <AreaChart options={optionsWithData} chartCSS={{ ...defaultCSS, ...chartCSS }} />
}
